module.exports = __webpack_public_path__ + "img/skull_16.9703fcf1.png";